import { createSVGLogo, getRotateCSS, getScreenRatio, updateSpriteSheet } from './helpers/DOMHelper'
import { ease, easeInWord, easeOutWord } from './helpers/EaseHelper'
import { Mouse } from './helpers/MouseHelper'
import View from './View'
/**
 * class Intro
 */

export const STATE_TITLE = 'intro--title'
export const STATE_TITLE_INTRO = 'intro--title-intro'
export const STATE_TITLE_OUTRO = 'intro--title-outro'
export const STATE_DESCRIPTION = 'intro--description'
export const STATE_DESCRIPTION_INTRO = 'intro--description-intro'
export const STATE_DESCRIPTION_OUTRO = 'intro--description-outro'
export const STATE_WAITING = 'intro--waiting'
export const STATE_OVER = 'intro--over'
export const STATE_INIT = 'intro--init'


class Intro extends View {
  /**
   * constructor
   */
  constructor (el, onStateChange=()=>{}, onComplete=()=>{}) {
    super(el, onStateChange)
    this.completeHandler = onComplete
    this.state = STATE_INIT
    this.plane = this.view.querySelector('.intro__plane')
    this.logo = createSVGLogo(this.plane, 'intro')
    this.button = this.view.querySelector('.intro__cta')
    this.letters = this.logo.letters
    this.letters.map(letter => letter.style.opacity = 0)
    this.fxProps = {
      rotateX: 0,
      rotateY: 0,
      scale: 0.8
    }
    this.timeoutLetters = null
    this.timeoutShowComplete = null
  }

  showHandler (resolve) {
    const onShowComplete = () => {
      this.state = STATE_TITLE
      setTimeout(this.next, 5000)
      resolve()
    }
    this.state = STATE_TITLE_INTRO
    this.timeoutLetters = setTimeout(() => {
      this.letters.map(easeInWord)
      ease(this.fxProps).to({scale: 1}, 5000).start()
    }, 4000)
    this.timeoutShowComplete = setTimeout(onShowComplete, 2000)
  }

  hideHandler (resolve) {
    this.onComplete()
    resolve()
  }

  skip () {
    clearTimeout(this.timeoutLetter)
    clearTimeout(this.timeoutShowComplete)
    this.onComplete()
  }

  showText () {
    const title = document.querySelector('#intro .intro__title')
    const text = document.querySelector('#intro .intro__text')
    const onShowComplete = () => { this.state = STATE_DESCRIPTION }
    this.state = STATE_DESCRIPTION_INTRO
    easeInWord(title)
    easeInWord(text)
    setTimeout(onShowComplete, 600)
  }

  onComplete () {
    this.state = STATE_OVER
    this.completeHandler()
  }

  update (time, delta) {
    if (this.state === STATE_OVER) return
    this.fxProps.rotateX += (Mouse.ry - this.fxProps.rotateX) * 0.1
    this.fxProps.rotateY += (Mouse.rx - this.fxProps.rotateY) * 0.1
    this.plane.style.transform = getRotateCSS(this.fxProps.rotateX * -1, this.fxProps.rotateY, 0, 10) + ` scale3d(${this.fxProps.scale}, ${this.fxProps.scale}, 1) translateZ(100px)`
    this.logo.svg.style.transform = `scale3d(${0.8 * getScreenRatio()}, ${0.8 * getScreenRatio()}, 1)`
  }

  next = () => {
    const isDisplayed = getComputedStyle(this.view).getPropertyValue('display') !== 'none'

    const onLogoOutro = () => { this.showText() }

    const COUNT_FRAME_MAX = 15

    const onButtonOver = () => {
      ease({ value: 0 })
      .to({ value: COUNT_FRAME_MAX - 1 }, 350)
      .onUpdate(o => { updateSpriteSheet(this.button, '300px', o.value) })
      .start()
    }

    const onButtonOut = () => {
      ease({ value: COUNT_FRAME_MAX - 1 })
      .to({ value: 0 }, 350)
      .onUpdate(o => { updateSpriteSheet(this.button, '300px', o.value) })
      .start()
    }

    if (!isDisplayed) return

    if (this.state === STATE_TITLE) {
      this.state = STATE_TITLE_OUTRO
      this.letters.map(easeOutWord)
      ease(this.fxProps).to({scale: 1.2}, 5000).start()
      setTimeout(onLogoOutro, 2000)
      this.view.addEventListener('click', this.next)
      this.button.addEventListener('mouseover', onButtonOver)
      this.button.addEventListener('mouseout', onButtonOut)
    }

    if (this.state === STATE_DESCRIPTION) {
      const title = document.querySelector('#intro .intro__title')
      const text = document.querySelector('#intro .intro__text')
      this.state = STATE_DESCRIPTION_OUTRO
      easeOutWord(title)
      easeOutWord(text)
      this.view.removeEventListener('click', this.next)
      this.button.removeEventListener('mouseover', onButtonOver)
      this.button.removeEventListener('mouseout', onButtonOut)
      setTimeout(() => this.onComplete(), 1500)
    }
  }
}
export default Intro



// WEBPACK FOOTER //
// ./src/scripts/Intro.js